import { locales } from "@/i18n/locales.mjs";
import { demoScope } from "@/lib/workspace-fetch";

export type DemoAccountAction = { action: "logout" } | { action: "language"; locale: typeof locales[number] };

/** Only preferences and the presenter's own sign-out cross the frame boundary. */
export function parseDemoAccountAction(value: unknown): DemoAccountAction | null {
  if (!value || typeof value !== "object") return null;
  const data = value as Record<string, unknown>;
  if (data.action === "logout") return { action: "logout" };
  if (data.action === "language" && locales.some(locale => locale === data.locale)) {
    return { action: "language", locale: data.locale as typeof locales[number] };
  }
  return null;
}

export function requestDemoAccountAction(action: DemoAccountAction): boolean {
  const scope = demoScope();
  if (!scope || window.parent === window) return false;
  window.parent.postMessage({ type: "aulyn-demo-account", sessionId: scope.sessionId, role: scope.role, ...action }, window.location.origin);
  return true;
}

/** A remembered workspace follows the presentation's current locale. */
export function localizeDemoWorkspace(path: string, locale: string): string {
  return `/${locale}${path.replace(/^\/(?:pt-BR|en-GB|es-ES)(?=\/)/, "")}`;
}
